/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Up_To_DateInputs */

const en_mobile_ota_up_to_date = /** @type {(inputs: Mobile_Ota_Up_To_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already up to date`)
};

const es_mobile_ota_up_to_date = /** @type {(inputs: Mobile_Ota_Up_To_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya está actualizada`)
};

/**
* | output |
* | --- |
* | "Already up to date" |
*
* @param {Mobile_Ota_Up_To_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_up_to_date = /** @type {((inputs?: Mobile_Ota_Up_To_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Up_To_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_up_to_date(inputs)
	return en_mobile_ota_up_to_date(inputs)
});